import axios from 'axios';
import store from '../store';

const APP_AUTH_TK = process.env.VUE_APP_AUTH_TK;
const APP_AUTH_ME = process.env.VUE_APP_AUTH_ME;

const app = {
    validate() {
        const token = JSON.parse(localStorage.getItem(APP_AUTH_TK));
        const user = JSON.parse(localStorage.getItem(APP_AUTH_ME));
        if (token) {
            axios.defaults.headers['Authorization'] = token.token;
            app.refresh();
            if (user) {
                store.commit('user', user);
            }
            // console.log('vm :',vm);
            console.log('refresh Notification_Counter : ', new Date);
            (new Vue()).$socket.emit('notificationupdate', { key: 'notifycount', user })
        } else {
            console.log('-- token kosong login --');
        }
    },
    refresh(interval) {
        if (interval) {
            if (window.tokenRefreshInterval) clearInterval(window.tokenRefreshInterval);
            window.tokenRefreshInterval = setInterval(app.refresh, interval);
        }

        const token = JSON.parse(localStorage.getItem(APP_AUTH_TK));
        // const user = JSON.parse(localStorage.getItem(APP_AUTH_ME));
        if (token && token.refresh_token) {
            app.tokenRefreshed = (app.tokenRefreshed || 0) + 1;

            axios.post('/auth/refresh', { refresh_token: token.refresh_token }).then((resp) => {
                const { data } = resp;
                if (data) {
                    localStorage.setItem(APP_AUTH_TK, JSON.stringify(data));
                    axios.defaults.headers['Authorization'] = data.token;
                }
            }).catch((err)=>{ 
                console.log(err);
                // console.log('-- paksa login --');
                clearInterval(window.tokenRefreshInterval);
                window.localStorage.clear();
                window.location.reload();
            });
        }
    },
}

export default app;